module.exports = __webpack_public_path__ + "media/react/mcat/pages/lesson_groups/assets/nodoc-20b44ba4ffe869e77b25858766c650a6.svg";